import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = {
  key: 1,
  class: "activity-sidebar__no-content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No new notifications.", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SidebarNotificationComponent = _resolveComponent("SidebarNotificationComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.notifications && $props.notifications.length)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 0,
          name: "list",
          tag: "ul"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.notifications, (notification) => {
              return (_openBlock(), _createBlock(_component_SidebarNotificationComponent, {
                key: notification.id,
                notification: notification
              }, null, 8 /* PROPS */, ["notification"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}